import React from 'react';
const layers = [{
  num: '01',
  name: 'Immediate Utility',
  timeline: 'Now – 6 mo',
  what: 'B2B widget: tourism boards, events, hospitality.',
  how: 'Intelligence-as-a-Service. Powers personalization, drives site visitors into Navi.',
  accent: '#4A90D9',
  accentBg: 'rgba(74, 144, 217, 0.06)',
  highlight: false
}, {
  num: '02',
  name: 'Consumer Access',
  timeline: '6 – 12 mo',
  what: 'Sponsored guides + location-aware ads. High-intent local audience.',
  how: 'Users engage sponsored content. Navi nudges ads at the moment of decision.',
  accent: '#a78bfa',
  accentBg: 'rgba(167, 139, 250, 0.06)',
  highlight: false
}, {
  num: '03',
  name: 'The Data Play',
  timeline: '12 – 36 mo',
  what: "The dataset that doesn't exist yet. Compounds with every walk.",
  how: 'Walkability scores, street-level routing, pedestrian infra. API & licensing.',
  accent: '#34d399',
  accentBg: 'rgba(52, 211, 153, 0.06)',
  highlight: true
}];
export function RevenueSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-316">
      <div className="flex flex-row w-full h-full min-h-0 relative overflow-hidden" data-id="element-317">
        {/* LEFT PANEL — Title + Quote */}
        <div className="flex flex-col justify-center flex-shrink-0 relative z-10" style={{
        width: '40%',
        padding: 'var(--slide-padding) clamp(2rem, 4vw, 3.5rem) var(--slide-padding) clamp(2rem, 6vw, 6rem)'
      }} data-id="element-318">
          {/* Blue italic label */}
          <p className="italic font-semibold animate-fade-slide" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          marginBottom: 'clamp(0.5rem, 1vw, 0.75rem)',
          animationDelay: '0.1s'
        }} data-id="element-319">
            Monetization
          </p>

          {/* Title */}
          <h1 className="font-black tracking-tight leading-[0.95] text-white animate-fade-slide" style={{
          fontSize: 'var(--title-size)',
          marginBottom: 'clamp(2rem, 5vw, 4rem)',
          animationDelay: '0.15s'
        }} data-id="element-320">
            Value compounds at every layer.
          </h1>

          {/* Punchline quote */}
          <div className="animate-fade-slide" style={{
          borderLeft: '2px solid rgba(74, 144, 217, 0.4)',
          paddingLeft: 'clamp(0.75rem, 1.5vw, 1.25rem)',
          animationDelay: '0.5s'
        }} data-id="element-321">
            <p style={{
            color: 'rgba(255,255,255,0.55)',
            fontSize: 'var(--body-size)',
            lineHeight: '1.6'
          }} data-id="element-322">
              The consumer app isn't the business. It's the growth engine that
              generates the data that{' '}
              <span className="font-bold" style={{
              color: '#4A90D9'
            }} data-id="element-323">
                IS
              </span>{' '}
              the business.
            </p>
          </div>
        </div>

        {/* VERTICAL DIVIDER */}
        <div className="flex-shrink-0 self-center animate-fade-slide" style={{
        width: '1px',
        height: '60%',
        background: 'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.1) 30%, rgba(255,255,255,0.1) 70%, rgba(255,255,255,0) 100%)',
        animationDelay: '0.2s'
      }} data-id="element-324" />

        {/* RIGHT PANEL — Cards */}
        <div className="flex-1 flex flex-col justify-center min-h-0 overflow-hidden" style={{
        padding: 'var(--slide-padding) clamp(2rem, 5vw, 5rem) var(--slide-padding) clamp(1.5rem, 3vw, 3rem)',
        gap: 'clamp(0.6rem, 1.2vw, 1rem)'
      }} data-id="element-325">
          {layers.map((l, i) => <div key={l.num} className="animate-fade-slide rounded-lg relative overflow-hidden" style={{
          background: l.highlight ? 'linear-gradient(135deg, rgba(43,124,184,0.12) 0%, rgba(52,211,153,0.10) 100%)' : l.accentBg,
          padding: 'clamp(0.9rem, 1.8vw, 1.4rem) clamp(1rem, 2vw, 1.5rem)',
          animationDelay: `${0.22 + i * 0.1}s`,
          ...(l.highlight ? {} : {
            borderLeft: `3px solid ${l.accent}`
          })
        }} data-id="element-326">
              {/* Animated gradient border for highlight card */}
              {l.highlight && <div className="absolute inset-0 rounded-lg pointer-events-none" style={{
            padding: '1px',
            background: 'linear-gradient(var(--gradient-angle, 0deg), #4A90D9, #34d399, #a78bfa, #4A90D9)',
            mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            maskComposite: 'exclude',
            WebkitMaskComposite: 'xor',
            animation: 'gradient-rotate 4s linear infinite',
            opacity: 0.5
          }} data-id="element-327" />}
              {/* Watermark number */}
              <span className="absolute font-black pointer-events-none select-none" style={{
            top: '50%',
            right: 'clamp(0.5rem, 1.5vw, 1.5rem)',
            transform: 'translateY(-50%)',
            fontSize: 'clamp(3rem, 6vw, 5.5rem)',
            color: l.accent,
            opacity: 0.06,
            lineHeight: 1,
            fontVariantNumeric: 'tabular-nums'
          }} data-id="element-328">
                {l.num}
              </span>

              {/* Card content */}
              <div className="relative z-10" data-id="element-329">
                {/* Name + Timeline row */}
                <div className="flex items-center" style={{
              gap: 'clamp(0.5rem, 1vw, 0.75rem)',
              marginBottom: 'clamp(0.4rem, 0.8vw, 0.6rem)'
            }} data-id="element-330">
                  <p className="font-bold leading-snug" style={{
                color: l.highlight ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.85)',
                fontSize: 'clamp(0.9rem, 1.5vw, 1.15rem)'
              }} data-id="element-331">
                    {l.name}
                  </p>
                  <span className="rounded-full font-medium flex-shrink-0" style={{
                color: l.accent,
                fontSize: 'clamp(0.5rem, 0.8vw, 0.65rem)',
                padding: 'clamp(1px, 0.2vw, 3px) clamp(6px, 0.8vw, 10px)',
                border: `1px solid ${l.accent}33`,
                backgroundColor: `${l.accent}11`
              }} data-id="element-332">
                    {l.timeline}
                  </span>
                </div>

                {/* What */}
                <p className="leading-snug" style={{
              color: l.highlight ? 'rgba(255,255,255,0.75)' : 'rgba(255,255,255,0.55)',
              fontSize: 'var(--body-size)',
              marginBottom: 'clamp(0.15rem, 0.3vw, 0.25rem)'
            }} data-id="element-333">
                  {l.what}
                </p>

                {/* How */}
                <p className="leading-snug" style={{
              color: 'rgba(255,255,255,0.3)',
              fontSize: 'clamp(0.6rem, 1vw, 0.8rem)'
            }} data-id="element-334">
                  {l.how}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}